import React from 'react';
import PropTypes from 'prop-types';
import styles from '../table.css';

function ImportedShapefileProperties({
  activePropertyIndex,
  onClick,
  properties = [],
}) {
  return (
    <table className={styles.table}>
      <tbody>
        {properties.map((property, index) => {
          const isActive = activePropertyIndex === index;
          const rowStyles = isActive ? styles.active : '';
          return (
            <tr
              className={rowStyles}
              data-is-active={isActive}
              data-test-id={`imported-shapefile-property-row-${index}`}
              id={`${index}`}
              key={property.name}
              onClick={onClick}
            >
              <td
                data-test-id={`imported-shapefile-property-row-value-${index}`}
              >
                {property.name}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

ImportedShapefileProperties.propTypes = {
  activePropertyIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  properties: PropTypes.array.isRequired,
};

export default ImportedShapefileProperties;
